import {
    ArrowRightIcon,
    MagnifyingGlassIcon as SearchIcon,
} from "@wags/ui/product-icons.tsx";
import { SkeletonBox } from "skullet/react";

import { cn } from "@wags/ui/ui-utils";
import { HeaderWordmark } from "@/components/Header";

export function DesktopSearchBarV2Skeleton() {
    return (
        <div
            aria-hidden
            className="flex h-12 w-125 items-center gap-2 rounded-nested border-shadow bg-true-white pr-1.5 pl-4"
        >
            <SearchIcon className="size-5 shrink-0 text-ink-muted" />
            <span className="flex-1 truncate text-body-small text-doberman-black/45">
                Describe your perfect dog
            </span>
            {/* oxlint-disable-next-line shadcn/no-arbitrary-values -- 6px radius has no radius step */}
            <span className="ml-1 flex size-9 shrink-0 items-center justify-center rounded-[6px] bg-doberman-black/[0.06] text-doberman-black/50">
                <ArrowRightIcon className="size-4" />
            </span>
        </div>
    );
}

export function MobileSearchBarV2Skeleton({
    variant = "results",
    wordmarkClassName,
    wordmarkStateful = true,
}: {
    variant?: "results" | "feed";
    wordmarkClassName?: string;
    wordmarkStateful?: boolean;
}) {
    const isFeed = variant === "feed";
    return (
        <div aria-hidden className="flex w-full flex-col gap-2.5">
            <div className="border-shadow flex h-12 w-full items-center gap-2 rounded-nested bg-true-white px-4">
                <div className="flex min-w-0 flex-1 items-center gap-2">
                    <SearchIcon className="size-5 shrink-0 text-ink-muted" />
                    <span className="truncate text-body-small text-doberman-black/45">
                        Describe your perfect dog
                    </span>
                </div>
                <HeaderWordmark
                    stateful={wordmarkStateful}
                    compact
                    className={cn(
                        "ml-1 size-8 shrink-0 text-doberman-black/40",
                        wordmarkClassName,
                    )}
                />
            </div>
            {!isFeed && (
                <div className="flex items-center gap-2">
                    {[92, 96, 80].map((width) => (
                        <SkeletonBox
                            key={width}
                            className="shrink-0"
                            width={width}
                            height={36}
                            radius="var(--radius-nested)"
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export function DesktopFilterChipsV2Skeleton() {
    return (
        <div aria-hidden className="flex w-full items-center gap-2">
            {[92, 112, 88, 76, 84].map((width) => (
                <SkeletonBox
                    key={width}
                    className="shrink-0"
                    width={width}
                    height={38}
                    radius="var(--radius-nested)"
                />
            ))}
        </div>
    );
}
